<template>
  <v-form ref="form" @submit.prevent>
    <v-container class="px-8">
      <v-row no-gutters justify="center">
        <v-col cols="12" md="8">
          <h2 class="loginTheme--text">Redefinir Senha</h2>
        </v-col>
        <v-col cols="12" md="8">
          <h4 class="mt-5 font-weight-light">
            Digite sua nova senha
          </h4>
        </v-col>
        <v-col cols="12" md="8" class="mt-8">
          <v-text-field
            v-model="senha"
            :rules="[v => !!v || 'Senha é obrigatória', v => v.length >= 6 || 'Senha deve ter no mínimo 6 caracteres']"
            :type="verSenha ? 'text' : 'password'"
            :append-icon="verSenha ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="verSenha = !verSenha"
            class="mt-8"
            label="Digite sua nova senha"
            outlined
            color="loginTheme"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8">
          <v-text-field
            :value="senhaConfirmacao"
            @input="v => $emit('update:senhaConfirmacao', v)"
            :rules="[v => !!v || 'Confirmação da senha é obrigatória', v => v === senha || 'As senhas não são iguais']"
            :type="verSenhaConfirmacao ? 'text' : 'password'"
            :append-icon="verSenhaConfirmacao ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="verSenhaConfirmacao = !verSenhaConfirmacao"
            label="Confirme sua nova senha"
            outlined
            color="loginTheme"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8">
          <v-btn @click="submit" type="submit" class="mt-5" color="loginTheme" dark rounded block large
            >Alterar Senha</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import authenticationService from '@/services/authentication'

export default {
  data: () => ({
    senha: '',
    senhaConfirmacao: '',
    verSenha: false,
    verSenhaConfirmacao: false
  }),
  computed: {
    token() {
      return this.$route.query.token
    }
  },
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) return

      this.$showLoading()
      try {
        const { data } = await authenticationService.redefinirSenha({
          senha: this.senha,
          token: this.token
        })

        this.$showSuccessMessage(data.message)

        this.$router.push({ name: 'Login' })
      } catch (error) {
        this.$showErrorMessage(error.response.data.message)
      } finally {
        this.$hideLoading()
      }
    }
  }
}
</script>

<style></style>
